$(document).ready(function() {

	// responzivní menu
	var ww = document.body.clientWidth;
	
	if ($(".JS-responsive-true").length > 0) {
		var adjustMenu = function() {
			if (ww < 980) {
				$(".toggleMenu").css("display", "inline-block");
				if (!$(".toggleMenu").hasClass("active")) {
					$(".menu").hide();
				} else {
					$(".menu").show();
				}

				$(".menu li").unbind('mouseenter mouseleave');

				if ($(".PR-anchor").length == 0) {
					$(".menu li a.parent").each(function(index, el) {
						var $el = $(this);
						var $odkaz = $el.clone();
						$odkaz.removeClass('parent').addClass('PR-anchor').text('');
						$el.closest('li').prepend($odkaz);
					});
				}

				$(".menu li a.PR-anchor").unbind('click').bind('click', function(e) {
					e.preventDefault();
					$(this).parent("li").toggleClass("hover");
				});
			}
			else if (ww >= 979) {
				$(".toggleMenu").css("display", "none");
				$(".menu").show();
				$(".menu li").removeClass("hover");
				$(".menu li a").unbind('click');
				$(".menu li").unbind('mouseenter').bind('mouseenter', function() {
					$(this).toggleClass('hover', true);
				});
				$(".menu li").unbind('mouseleave').bind('mouseleave', function() {
					$(this).toggleClass('hover', false);
				});
			}
		}

		$(".menu li a").each(function() {
			if ($(this).next().length > 0) {
				$(this).addClass("parent");
			};
		})

		$(".toggleMenu").click(function(e) {
			e.preventDefault();
			$(this).toggleClass("active");
			$(".menu").toggle();
		});
		adjustMenu();

		$(window).bind('resize orientationchange', function() {
			ww = document.body.clientWidth;
			adjustMenu();
		});
	} else {
		$(".toggleMenu").css("display", "none");
		$(".menu").show();
		$(".menu li").removeClass("hover");
		$(".menu li a").unbind('click');
		$(".menu li").unbind('mouseenter').bind('mouseenter', function() {
			$(this).toggleClass('hover', true);
		});
		$(".menu li").unbind('mouseleave').bind('mouseleave', function() {
			$(this).toggleClass('hover', false);
		});
	}
});